module.exports = __webpack_public_path__ + "static/media/coverage.68a8342f.svg";